import {
  type FC,
} from "react";


import "./VolunteersLayout.scss";
import { Outlet } from "react-router-dom";

export const VolunteersLayout: FC = () => {

  return (
    <div className="volunteers-table-page-container">
      <Outlet />
    </div>
  );
};
